import { useContext } from 'react';
import { ReportingContext } from 'context/ReportingContext';

const useReportingContext = () => {
  return { ...useContext(ReportingContext) };
};

export default useReportingContext;
